<template>
  <b-button
    :class="[
      'ai-optimize-btn',
      'mt-2 mb-0 ovr-button__inverted actions-save',
      { 'disabled': disabled }
    ]"
    :disabled="disabled"
    @click="handleOptimize"
    variant="primary"
    v-b-tooltip.hover
    :title="tooltipText"
  >
    <svg
      class="ai-icon mr-2"
      viewBox="0 0 24 24"
      width="16"
      height="16"
    >
      <path
        fill="currentColor"
        d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12.5,6.2L15.9,10H13.5V14H11.5V10H9.1L12.5,6.2M12.5,17.8L9.1,14H11.5V10H13.5V14H15.9L12.5,17.8Z"
      />
    </svg>
    Optimize with AI
  </b-button>
</template>

<script>
export default {
  name: 'AIOptimizeButton',
  props: {
    isOptimizing: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasContent: {
      type: Boolean,
      default: false
    },
    hasBeenUsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltipText() {
      if (!this.hasContent) {
        return 'Add some content to your entry before optimizing with AI.';
      }
      if (this.hasBeenUsed) {
        return 'Review previous AI suggestions or run a fresh optimization.';
      }
      return 'Use AI to improve the clarity, professionalism, and structure of your entry content.';
    }
  },
  methods: {
    handleOptimize() {
      if (!this.disabled) {
        // Hide tooltip immediately when clicked
        this.$root.$emit('bv::hide::tooltip');
        this.$emit('optimize');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.ai-optimize-btn {
  // Match existing save button styling with purple gradient
  background: linear-gradient(135deg, #7b68ee 0%, #9370db 100%) !important;
  border: none !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 0.375rem 22px;
  margin-left: 30px;
  color: #ffffff !important;
  position: relative;
  overflow: hidden;
  
  &:hover:not(.disabled) {
    background: linear-gradient(135deg, #6a5acd 0%, #8a2be2 100%) !important;
    color: #ffffff !important;
    border-color: transparent !important;
  }
  
  &:focus {
    color: #ffffff !important;
    box-shadow: 0 0 0 0.2rem rgba(123, 104, 238, 0.25) !important;
    border-color: transparent !important;
  }
  
  &:active:not(.disabled) {
    background: linear-gradient(135deg, #5d4fb3 0%, #7a1fa2 100%) !important;
    color: #ffffff !important;
    border-color: transparent !important;
  }
  
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #6c757d !important;
    
    &:hover {
      transform: none;
      box-shadow: none;
      background: #6c757d !important;
    }
  }
  
  .ai-icon {
    flex-shrink: 0;
    transition: transform 0.3s ease;
  }
  
  &:hover:not(.disabled) .ai-icon {
    transform: scale(1.1) rotate(180deg);
  }
}

// Follow the responsive pattern from existing styles
@media screen and (max-width: 950px) {
  .ai-optimize-btn {
    display: block;
    margin: 10px auto 0 auto;
    width: auto;
  }
}
</style>